/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable react-hooks/exhaustive-deps */
import { BackArrow, Chevron } from '@ahamove/icons';
import type { ItemDescription } from '@ahm/api-wrappers-core';
// import { useAuth } from '@ahm/react-auth';
import { Button, CloseButton, Stack, Text, rem } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { openContextModal } from '@mantine/modals';
import debounce from 'lodash/debounce';
import { usePathname } from 'next/navigation';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { ModalName } from '@/components/modals';
// import { useGetItemTrend } from '@/features/booking/api/special-request';
import { getServiceType } from '@/lib/utils';
import { useBookingStore } from '@/stores/booking/booking-store-provider';

const TruckItemDescriptionsSection = () => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  // const { status } = useAuth();
  const { itemDescriptions } = useBookingStore((state) => state);
  const [itemDesc, setItemDesc] = useState<ItemDescription[]>(itemDescriptions);
  // const { data: trends } = useGetItemTrend({
  //   enabled: status === 'authenticated',
  // });

  const {
    setItemDescriptions,
    createOrderError,
    // truckSelectedGroup,
    // setCreateOrderError,
  } = useBookingStore((state) => state);

  const pathname = usePathname();

  const { isTruckService } = useMemo(
    () => getServiceType(pathname),
    [pathname]
  );
  // const handleItemDescriptionClick = (code: string) => {
  //   const newDescriptions = itemDesc.some((desc) => desc?.code === code)
  //     ? itemDesc.filter((desc) => desc?.code !== code)
  //     : isTruckService
  //       ? ([trends?.find((item) => item.code === code)] as ItemDescription[])
  //       : ([
  //           ...itemDesc,
  //           trends?.find((item) => item.code === code),
  //         ] as ItemDescription[]);
  //   setItemDesc(newDescriptions);
  //   setCreateOrderError(null);
  // };

  useEffect(() => {
    setItemDesc(itemDescriptions);
  }, [itemDescriptions]);

  const debouncedSetItemDesc = useCallback(
    debounce(() => {
      setItemDescriptions(itemDesc);
    }, 300),
    [itemDesc]
  );

  useEffect(() => {
    debouncedSetItemDesc();
    return () => {
      debouncedSetItemDesc.cancel();
    };
  }, [debouncedSetItemDesc]);

  const showItemDescriptionsModal = () => {
    openContextModal({
      modal: ModalName.TruckItemDescriptionsList,
      innerProps: {},
      title: 'Chọn loại hàng hóa',
      h: 'fit-content',
      closeOnClickOutside: false,
      withCloseButton: true,
      closeButtonProps: {
        pos: isMobile ? 'absolute' : 'unset',
        mr: isMobile ? 0 : rem(-10),
        left: rem(12),
        top: isMobile ? 'auto' : rem(8),
        radius: 'xl',

        icon: isMobile ? (
          <BackArrow width={22} height={22} />
        ) : (
          <CloseButton width={22} height={22} />
        ),
      },
      fullScreen: isMobile,
      centered: true,
      maw: rem(440),
      w: '100%',
      styles: {
        root: {
          zIndex: 1,
        },
        title: {
          flex: 1,
          textAlign: isMobile ? 'center' : 'left',
          fontSize: 18,
          fontWeight: 700,
        },
        header: {
          minHeight: isMobile ? rem(45) : rem(56),
          padding: '0px 16px',
          borderBottom: `1px solid var(--mantine-color-neutral-0)`,
        },
        body: {
          padding: 0,
        },
        content: {
          minHeight: rem(600),
        },
      },
    });
  };

  const isHighlightBtnOrder = useMemo(
    () => createOrderError === 'package-detail' && itemDesc?.length === 0,
    [createOrderError, itemDesc]
  );

  return (
    <Button
      c="neutral"
      h="auto"
      fullWidth
      mih={{ base: rem(48), md: rem(56) }}
      radius={rem(12)}
      onClick={showItemDescriptionsModal}
      px={12}
      py={8}
      variant="white"
      rightSection={<Chevron className="size-5 md:size-6" />}
      justify="space-between"
      styles={{
        root: {
          border: '1px solid var(--mantine-color-neutral-1)',
          background: isHighlightBtnOrder
            ? 'var(--mantine-color-red-0)'
            : 'white',
        },
      }}
    >
      <Stack
        gap={4}
        ta="left"
        style={{
          background: isHighlightBtnOrder
            ? 'var(--mantine-color-red-0)'
            : 'white',
        }}
      >
        <Text fz={14} fw={600}>
          Loại hàng hóa
          {isTruckService ? (
            <Text fz={14} component="span" c="red">
              *
            </Text>
          ) : null}
        </Text>
        <Text fz={12}>
          {itemDescriptions.length > 0
            ? itemDescriptions[0]?.keyword
            : 'Chọn loại hàng hóa'}
        </Text>
      </Stack>
    </Button>
  );
};
export default TruckItemDescriptionsSection;
